<template>
	<div class="layer-project" data-project-name="omron-healthcare">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">OMRON<br />HEALTHCARE</h1>
					<a href="https://omron-healthcare.co.kr/" class="link" target="_blank"
						>https://omron-healthcare.co.kr/</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<!--<div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">프로젝트 결과물, 업무 수행 및 전문성 강화에 필요한 지식과 사내 전문가, 사외 전문 업체 정보를 공유/관리할 수 있는 지식과 사람이 서로 연결되고 함께 움직이는 통합 시스템입니다.
                </p>
                <p class="project-overview-txt">체계적인 정보 분류, 다양한 지식의 효과적인 노출, 지식/결과물 등록 프로세스 단순화, 검색 기능 및 개인화 서비스 강화를 통하여 좀 더 쉽고 정확하게 지식을 공유하고 활용할 수 있도록 제작하였고, 
                    시스템 활성화와 참여 동기를 부여하기 위해 시스템 내 다양한 활동에 따른 포인트 제도를 도입하였으며 관리 기능을 개선하여 업무 효율성과 시스템 운영을 용이하게 하였습니다.
                </p>
                <div class="project-overview-diagram">
                    <ul class="diagram01">
                        <li><span>Asset</span></li>
                        <li><span>Share</span></li>
                        <li><span>Assessement</span></li>
                        <li><span>Reward</span></li>
                    </ul>
                    <ul class="diagram02">
                        <li><span>INNOCEAN<br>Discover</span></li>
                    </ul>
                </div>                
            </div>-->
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/overview@w.jpg"
				/>
			</section>

			<section class="section01 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section01-01@w.jpg"
				/>
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section01-02@w.jpg"
				/>
			</section>

			<section class="section02 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section02-01@w.jpg"
				/>
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section02-02@w.jpg"
				/>
			</section>

			<section class="section03 full">
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section03-01@w.jpg"
				/>
				<img
					src=""
					alt=""
					data-src="/static/img/project-detail/omron-healthcare/section03-02@w.jpg"
				/>
			</section>

			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">SAMSUNG SVC</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/omron-healthcare/ci.png) 50%/80px
		45px no-repeat;
	background-color: #eee;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/omron-healthcare/bg-overview@m.jpg);
	}
	.project-client {
		background-size: 109px 22px;
	}
	.layer-project img {
		width: 100%;
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/omron-healthcare/bg-overview@t.jpg);
	}
	.project-client {
		background-size: 135px 27.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/omron-healthcare/bg-overview@w.jpg);
	}
	.project-client {
		background-size: 464px 93px;
	}
}

.project-overview {
	padding: 0;
}
.layer-project-detail > section {
	padding: 0;
}
@media screen and (max-width: 711px) {
	.layer-project-detail > .section03 {
		padding: 0 15px;
	}
	.section03 .inner-section {
		padding: 40px 0 40px;
		border-bottom: 2px solid #222;
	}
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		padding: 100px 0 80px;
		border-bottom: 2px solid #222;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		padding: 100px 0 150px;
		border-bottom: 2px solid #222;
	}
}
.project-visual > div {
	padding: 0;
}
.project-visual .project-tit + .link {
	margin-top: 25px;
}
</style>


// WEBPACK FOOTER //
// src/projects/omron-healthcare.vue